var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.24 55.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.29,18.35V15.71l-2.62,0,2.62,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.62,0A27.62,27.62,0,1,0,55.24,27.62,27.63,27.63,0,0,0,27.62,0ZM39.47,43.69H31.63a1.38,1.38,0,0,1-1.37-1.38V35.59H25v6.72a1.35,1.35,0,0,1-.4,1,1.38,1.38,0,0,1-1,.41H15.77a2.51,2.51,0,0,1-2.51-2.51V26.79a1.38,1.38,0,0,1,1.35-1.39h.07a1.41,1.41,0,0,1,1,.4,1.36,1.36,0,0,1,.4,1V40.94h6.23V35.35a3.94,3.94,0,0,1,.16-1.21,2,2,0,0,1,.31-.66A1.59,1.59,0,0,1,24,32.84h7.29a1.56,1.56,0,0,1,1.25.65,2.11,2.11,0,0,1,.32.64A4.24,4.24,0,0,1,33,35.35v5.59h6.23V26.79a1.38,1.38,0,0,1,.38-1,1.42,1.42,0,0,1,2,0,1.4,1.4,0,0,1,.38,1V41.18A2.52,2.52,0,0,1,39.47,43.69Zm6.71-16.47a1.35,1.35,0,0,1-1,.4h-.07a1.4,1.4,0,0,1-1-.51L27.61,10.58,11,27.15a1.35,1.35,0,0,1-1,.44,1.33,1.33,0,0,1-1-.4,1.35,1.35,0,0,1-.4-1,1.37,1.37,0,0,1,.45-1L25.83,8.47a2.52,2.52,0,0,1,3.55,0h0l5.9,5.9A1.38,1.38,0,0,1,36.66,13h2.67A2.71,2.71,0,0,1,42,15.71v2.67a1.35,1.35,0,0,1-.38,1,1.39,1.39,0,0,1-1,.42l5.42,5.42a1.36,1.36,0,0,1,.47,1A1.42,1.42,0,0,1,46.18,27.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.e75242b9a2cada4a1e761219f9bd5fb0.svg";
export { ForwardRef as ReactComponent };